import './configure'
import React from 'react'
import ReactDOM from 'react-dom'
import { ErrorBoundary } from '@sentry/react'
import { AppContainer } from 'react-hot-loader'

import { ErrorMessage } from 'components/ErrorMessage'
import { getStore, initStore } from './store'

const rootElement = document.getElementById('root')
initStore()
const store = getStore()
const Route = require('./routes').default

ReactDOM.render(
  <AppContainer>
    <ErrorBoundary fallback={<ErrorMessage />}>
      <Route store={store} />
    </ErrorBoundary>
  </AppContainer>,
  rootElement
)

if (module.hot) {
  module.hot.accept('./routes', () => {
    const NextRoute = require('./routes').default
    ReactDOM.render(
      <AppContainer>
        <ErrorBoundary fallback={<ErrorMessage />}>
          <NextRoute store={store} />
        </ErrorBoundary>
      </AppContainer>,
      rootElement
    )
  })
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/index.js